import { Tag } from "@/components/Common/Tag";
import { cn, getTextColor } from "@/lib/utils";
import { DEFAULT_TAG_COLOR } from "@/lib/const";
import { Tag as TagModel } from "@/types/v2";
import { sortTagsByShopOrder } from "@/lib/tags";

export const TagsList = ({
  tags,
  tagClassName,
  allTags = [],
}: {
  tags: string[];
  tagClassName?: string;
  allTags?: TagModel[];
}) => {
  const orderedTags = sortTagsByShopOrder(tags, allTags);
  return (
    <div className={"flex min-w-0 flex-row flex-wrap gap-2"}>
      {orderedTags.map((tag, index) => {
        const extendedTag = allTags.find(
          (t) => t.label.toLowerCase() === tag.toLowerCase()
        );
        return (
          <Tag
            key={`${tag}-${index}`}
            label={tag}
            className={cn(
              "cursor-pointer hover:bg-primary hover:text-primary-foreground",
              tagClassName
            )}
            style={
              extendedTag
                ? {
                    backgroundColor:
                      extendedTag.customColor ?? DEFAULT_TAG_COLOR,
                    color: getTextColor(
                      extendedTag.customColor ?? DEFAULT_TAG_COLOR
                    ),
                  }
                : undefined
            }
          />
        );
      })}
    </div>
  );
};
